import WorkDaysListPage from '@/pages/workdays/list'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventDaysPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <WorkDaysListPage portalMode="event" />
    </WorkspacePortalProvider>
  )
}
